import React, { useEffect, useState } from "react";
import axios from "axios";

const MouTable = () => {
  const [mous, setMous] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0); // To track the current page
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 10; // Number of items per page

  // Function to fetch MOUs for the current page
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/mous?page=${page}&size=${pageSize}`)
      .then((response) => {
        setMous(response.data._embedded.mous); // Assuming data comes in _embedded.mous
        setTotalPages(response.data.page.totalPages); // Fetch total pages from the response
        setLoading(false);
      })
      .catch((error) => {
        setError("Error fetching data");
        setLoading(false);
      });
  }, [page]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container">
      <h2 className="m-4">MOUs</h2>
      
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>MOU ID</th>
            <th>Title</th>
            <th>Date of Sign</th>
            <th>Date of End</th>
            <th>Partner Organization</th>
          </tr>
        </thead>
        <tbody>
          {mous.map((mou) => (
            <tr key={mou.mouId}>
              <td>{mou.mouId}</td>
              <td>{mou.title}</td>
              <td>{new Date(mou.dateOfSign).toLocaleString()}</td>
              <td>{new Date(mou.dateOfEnd).toLocaleString()}</td>
              <td>{mou.ptnOrg}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="d-flex justify-content-between">
        <button
          disabled={page === 0}
          onClick={() => setPage(page - 1)}
          className="btn btn-primary"
        >
          Previous
        </button>
        <span>
          Page {page + 1} of {totalPages}
        </span>
        <button
          disabled={page >= totalPages - 1}
          onClick={() => setPage(page + 1)}
          className="btn btn-primary"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default MouTable;
